import dayjs from "dayjs";
import { Event } from "../../Event";

export class BudgetFollowupReceiveEmailEvents extends Event {
    // public onBlur = (value: any, setField: any, setState: any, setFieldValue: any) => {
    //     console.log("value :> ", value)
    // }
}